// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import * as analytics from 'analytics/Analytics';
import * as CrisprConstants from 'constants/CRISPRConstants';
import FolderSelector from 'file-browser/FolderSelector';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import AssemblyList from './AssemblyList';
import CRISPRAssemblyActions from './CRISPRAssemblyActions';

const {ASSEMBLY_STEP} = CrisprConstants;

interface Props {
  assemblyCid: string;
  assemblies: Array<{
    name?: string;
    bases?: string;
  }>;
  finalizingAssemblies?: boolean;
  assembliesFolder?: string;
  analysis: CrisprConstants.CRISPRAnalysis;
}

export default function FinalizeAssembliesStep(props: Props): JSX.Element {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        CRISPRAssemblyActions.finalizeAssemblies(props.assemblyCid);
        analytics.track('crispr', 'finalized_assemblies');
      }}
    >
      <fieldset>
        <legend>Finalize Assemblies</legend>
        <AssemblyList
          analysis={props.analysis}
          assemblyCid={props.assemblyCid}
          assemblies={props.assemblies}
        />
        <FormGroup>
          <Row>
            <Col sm={12}>
              <Label>Folder</Label>
            </Col>
          </Row>
          <Row>
            <Col sm={5}>
              <FolderSelector
                enableRedesign={true}
                showInventory={true}
                value={props.assembliesFolder}
                onChange={(e) => {
                  CRISPRAssemblyActions.updateAssembly(props.assemblyCid, {
                    assembliesFolder: e.target.value,
                  });
                }}
                unsetOnFetchFail={true}
              />
            </Col>
          </Row>
        </FormGroup>
        <Button
          buttonStyle={ButtonStyle.PRIMARY}
          size={ButtonSize.SMALL}
          className="pull-right"
          type="submit"
          disabled={props.finalizingAssemblies}
          text={props.finalizingAssemblies ? 'Assembling...' : 'Assemble'}
        />
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.SMALL}
          onClick={(e) => {
            e.preventDefault();
            CRISPRAssemblyActions.updateAssembly(props.assemblyCid, {
              step: ASSEMBLY_STEP.SELECT_VECTOR,
            });
          }}
          disabled={props.finalizingAssemblies}
          text="Previous"
        />
      </fieldset>
    </form>
  );
}
